/* eslint-disable */


/**
 * Create styles for `<FileUpload />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<FileUpload />` styles
 */
const fileUploadStyles = ({ theme }) => ({});

export default fileUploadStyles;
